<template>
  <div
    class="my_public_index h-100"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div
      class="tooptipPart d_block z_index_913 module_edit_btn"
      v-if="isHover"
    >
      <my_edit_btn
        :module="module"
        v-if="has_my_edit_btn"
      ></my_edit_btn>
      <my_edit_btn
        :module="module"
        tabName="animation"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_edit_btn>
      <my_link_btn
        :module="module"
        v-if="has_my_link_btn"
      ></my_link_btn>
      <my_close_btn
        :module="module"
        :column="column"
        :moduleIndex="moduleIndex"
        v-if="has_my_close_btn && $store.state.app.view_pattern === 'pc'"
      ></my_close_btn>
    </div>
    <my_title_index :title="widgets_infor.title"></my_title_index>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "my_public_index",
  props: {
    module: {
      required: true,
      type: Object
    },
    column: {
      type: Object,
      default: null
    },
    moduleIndex: {
      type: Number,
      default: 0
    },
    has_my_edit_btn: {
      required: false,
      type: Boolean,
      default: true
    },
    has_my_link_btn: {
      required: false,
      type: Boolean,
      default: false
    },
    has_my_close_btn: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  computed: {
    widgets_infor () {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    }
  },
  data () {
    return {
      isHover: false
    };
  },
  methods: {
    module_isHover (val) {
      this.isHover = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/css/commonly.scss";
</style>



// WEBPACK FOOTER //
// src/components/my_public_index/index.vue